var _g, _g2, _circle, _circle2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_312_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1572 57.0063V51.0274L37.186 42.8441C40.0044 40.2875 42.2289 38.1435 43.8595 36.4122C45.5102 34.6608 46.6778 33.1107 47.3623 31.7619C48.0669 30.4132 48.4192 29.0543 48.4192 27.6854C48.4192 25.6723 47.7448 24.1121 46.396 23.0049C45.0472 21.8977 43.1448 21.3441 40.6888 21.3441C38.8368 21.3441 37.0552 21.6964 35.344 22.401C33.653 23.0854 32.1633 24.1021 30.8749 25.4508L27.7647 18.9888C29.6167 17.3179 31.7405 16.0395 34.1361 15.1538C36.5519 14.268 39.028 13.8251 41.5645 13.8251C44.6245 13.8251 47.2918 14.3586 49.5666 15.4255C51.8415 16.4925 53.5929 17.9923 54.8209 19.9249C56.069 21.8373 56.6931 24.0719 56.6931 26.6285C56.6931 28.3799 56.3508 30.1011 55.6664 31.7921C54.9819 33.463 53.764 35.3453 52.0126 37.4389C50.2813 39.5325 47.8354 42.0691 44.6748 45.0485L39.7527 49.6384H57.8103V57.0063H28.1572Z",
    fill: "black",
    fillOpacity: 0.45
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_312_495)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "url(#paint0_linear_312_495)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 40.5,
    stroke: "white",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_312_495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 85,
    height: 86
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.8384,
    r: 42.5,
    fill: "#84C5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_312_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4741 62.2471V32.4921L32.3441 35.7646L30.1991 29.4396L48.4041 22.9221H48.9541V62.2471H41.4741Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_312_495",
    x: 19.8882,
    y: 5.94781,
    width: 45.7997,
    height: 58.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.93869,
    result: "effect1_foregroundBlur_312_495"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_312_495",
    x: 0,
    y: 0,
    width: 87,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_312_495"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_495",
    x1: 42.5,
    y1: 0,
    x2: 84.663,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7D7F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.25e67b20723e37df596ccc4aab01121a.svg";
export { ForwardRef as ReactComponent };